import { DisabledPrompt } from "@bcm-dev/bcms-vite";
import { TableBody, TableColumnContainer, TableItemContainer, TableItemTextView, TableItemView, TableView } from "components/shared";
import { UICheckbox } from "components/ui";
import React from "react";
import { SVGAsset } from "res";

import "./styles.css";

/**
 * @function PaymentDistributionTable
 * @param {React.Component} children - Allows us to pass content/components.
 * @return {React.Component}
 * @exported true
 * @description The is the Payment Distribution Table for ParticipantDetailsPage
 */
export default function PaymentDistributionTable(props) {
  return (
    <TableView className="payment-distribution-table">
      <TableColumnContainer >
        <TableItemTextView className="priority-col" text="Priority" />
        <TableItemTextView className="name-col" text="Name" />
        <TableItemTextView className="account-number-col" text="Account Number" />
        <TableItemTextView className="account-type-col" text="Account Type" />
        <TableItemTextView className="amount-col" text="Amount" />
        <TableItemTextView className="sharing-remaining-col" text="Share Remaining" />
        <TableItemTextView className="action-col" />
      </TableColumnContainer>
      <TableBody>
      {props.children}
      </TableBody>

    </TableView>
  )
}

/**
 * @function PaymentDistributionTableRow
 * @param {STRING} paymentName - This sets the name of the payment distribution.
 * @param {STRING} paymentAmount - This sets the amount of the payment distribution.
 * @return {React.Component}
 * @exported true
 * @description The is the table row for the PaymentDistributionTable
 */
export function PaymentDistributionTableRow(props) {
  const paymentName = props.paymentName ?? "[paymentName]";
  const paymentAmount = props.paymentAmount ?? "[paymentAmount]";

  return (
    <TableItemContainer>
      <TableItemTextView className="priority-col" />
      <TableItemTextView className="name-col" text={"Primary"} />
      <TableItemTextView className="account-number-col" />
      <TableItemTextView className="account-type-col" />
      <TableItemTextView className="amount-col" text={"0.00"} />
      <TableItemView className="sharing-remaining-col">
        <DisabledPrompt>
          <UICheckbox label="" value={true}/>
        </DisabledPrompt>
      </TableItemView>
      <TableItemView className="action-col">
        <DisabledPrompt>
          <SVGAsset id="EditIcon" data-point={ `Payment_Distribution_Row_Edit_Icon_0` } className="edit-icon clickable" />
        </DisabledPrompt>
      </TableItemView>
    </TableItemContainer>
  )
}

/**
 * @function MobilePaymentDistributionTableRow
 * @param {STRING} paymentName - This sets the name of the payment distribution.
 * @param {STRING} paymentAmount - This sets the amount of the payment distribution.
 * @return {React.Component}
 * @exported true
 * @description The is the mobile table row for the ParticipantDetailsPage
 */
export function MobilePaymentDistributionTableRow(props) {
  const paymentName = props.paymentName ?? "Primary";
  const paymentAmount = props.paymentAmount ?? "$0.00";
  const paymentShareRemaining = props.paymentShareRemaining ?? "Yes";

  return (
    <div className="mobile-payment-distribution-table-row">
      <div className="payment-detail-container flex-container align-center">
        <div className="flex-width">
          <p className="payment-detail primary">
            <span className="detail-label">
              {paymentName}
            </span>
          </p>
          <p className="payment-detail account-number">
            <span className="detail-label">
              Account Number
            </span>
            <span className="detail-text">

            </span>
          </p>
          <p className="payment-detail amount">
            <span className="detail-label">
              Amount
            </span>
            <span className="detail-text">
              {paymentAmount}
            </span>
          </p>
          <p className="payment-detail sharing-remaining">
            <span className="detail-label">
              Sharing Remaining
            </span>
            <span className="detail-text">{ paymentShareRemaining }</span>
          </p>
        </div>
        <div className="set-width">
          <DisabledPrompt>
            <SVGAsset id="EditIcon" className="edit-icon clickable" />
          </DisabledPrompt>
        </div>
      </div>
    </div>
  )
}